import { mapToCanActivate, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { AccountClearCookiesComponent } from './shared/pages/account-clear-cookies/account-clear-cookies.component';
import { UnauthorizedPageComponent } from './shared/pages/unauthorized-page/unauthorized-page.component';
import { orderHarnessGuard } from './_core/guards/order-harness.guard';
import { dashboardRoutes } from './features/dashboard/dashboard.routes';
import { orderHarnessRoutes } from './features/order-harness/order-harness.routes';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: 'dashboard',
        canActivate: mapToCanActivate([AuthGuard]),
        children: dashboardRoutes,
    },
    {
        path: 'order-harness',
        canActivate: [AuthGuard, orderHarnessGuard],
        children: orderHarnessRoutes,
    },
    {
        path: 'unauthorized',
        component: UnauthorizedPageComponent,
    },
    {
        path: 'Account/ClearCookies',
        component: AccountClearCookiesComponent,
    },

    {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
];
